/**
 * Weather Code Utilities (Web)
 * Re-exports shared weather code logic and adds web-specific icon URL resolution.
 */

import {
  getWeatherIconName as sharedGetWeatherIconName,
  isPrecipitationWeatherCode,
  precipPopThreshold,
} from 'rainowls-shared'

export { isPrecipitationWeatherCode, precipPopThreshold }

// Icon name remapping: shared package → web SVG asset names
const iconNameRemap: Record<string, string> = {
  DayFoggy: 'FoggyWeather',
}

/**
 * Get weather icon name, remapped for web SVG assets
 */
export function getWeatherIconName(weatherCode: number, isDay = true): string {
  const name = sharedGetWeatherIconName(weatherCode, isDay)
  return iconNameRemap[name] ?? name
}

// Icon imports for web from rainowls-ui package (Vite handles these)
const iconModules = import.meta.glob('rainowls-ui/src/assets/icons/weather/*.svg', { eager: true, query: '?url', import: 'default' }) as Record<string, string>

// Build icon map from glob imports
const iconMap: Record<string, string> = {}
for (const path in iconModules) {
  const name = path.split('/').pop()?.replace('.svg', '') || ''
  iconMap[name] = iconModules[path]
}

/**
 * Get weather icon URL for a given weather code
 */
export function getWeatherIconUrl(weatherCode: number, isDay = true): string {
  const iconName = getWeatherIconName(weatherCode, isDay)
  return iconMap[iconName] || iconMap['DayClear'] || ''
}

// RainOwls color palette
export const weatherColors = {
  pop: '#60a5fa',      // Probability of precipitation
  popHigh: '#38bdf8',  // High probability (>=60%)
  rain: '#22c55e',     // Rain
  snow: '#38bdf8',     // Snow
}
